import { render, staticRenderFns } from "./MedicineList.vue?vue&type=template&id=06d23084"
import script from "./MedicineList.js?vue&type=script&lang=js&external"
export * from "./MedicineList.js?vue&type=script&lang=js&external"
import style0 from "./MedicineList.vue?vue&type=style&index=0&id=06d23084&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports